import { Directive, HostBinding, inject } from '@angular/core';

import { VudDropdownDirective } from './vud-dropdown.directive';

@Directive({
  selector: '[diVudDropdownMenu]',
  standalone: true,
})
export class VudDropdownMenuDirective {
  private readonly dropdown = inject(VudDropdownDirective);

  @HostBinding('class.show')
  get isVisible(): boolean {
    return this.dropdown.isOpen;
  }
}
